import { OrderProductSelectionEdge } from '../products/orderProducts.types';

interface GetOrderProductRowRadiiParams {
  selectionEdge: OrderProductSelectionEdge;
  isLastOrderProduct: boolean;
  hasHoverRadius: boolean;
  selectionRadius: number;
  cardRadius: number;
}

export const getOrderProductRowRadii = ({
  selectionEdge,
  isLastOrderProduct,
  hasHoverRadius,
  selectionRadius,
  cardRadius,
}: GetOrderProductRowRadiiParams) => {
  const isRoundedTop = selectionEdge === 'single' || selectionEdge === 'start';
  const isRoundedBottom = selectionEdge === 'single' || selectionEdge === 'end';

  const topRadius = isRoundedTop ? selectionRadius : 0;
  const selectedBottomRadius = isRoundedBottom ? selectionRadius : 0;
  const bottomRadius = isLastOrderProduct ? cardRadius : selectedBottomRadius;
  const hoveredBottomRadius = isLastOrderProduct ? cardRadius : selectionRadius;

  return {
    borderTopLeftRadius: topRadius,
    borderTopRightRadius: topRadius,
    borderBottomLeftRadius: bottomRadius,
    borderBottomRightRadius: bottomRadius,
    ...(selectionEdge === 'none' &&
      hasHoverRadius && {
        '&:hover': {
          borderTopLeftRadius: selectionRadius,
          borderTopRightRadius: selectionRadius,
          borderBottomLeftRadius: hoveredBottomRadius,
          borderBottomRightRadius: hoveredBottomRadius,
        },
      }),
  };
};
